module.exports = __webpack_public_path__ + "img/f3859b259740ecce5e1d0a2269e2dc13.png";